(() => {
  const bindClickToPlay = (root = document) => {
    const wraps = root.querySelectorAll(
      '[data-media-video-playback="click"]:not([data-media-video-bound])',
    );

    for (const wrap of wraps) {
      wrap.dataset.mediaVideoBound = "true";
      const video = wrap.querySelector("video");
      const playButton = wrap.querySelector("[data-media-video-play]");
      if (!video || !playButton) continue;

      const playVideo = () => {
        video.muted = false;
        const playPromise = video.play();
        wrap.classList.add("is-playing");
        playButton.hidden = true;

        if (playPromise && typeof playPromise.catch === "function") {
          playPromise.catch(() => {
            wrap.classList.remove("is-playing");
            playButton.hidden = false;
          });
        }
      };

      playButton.addEventListener("click", (event) => {
        event.preventDefault();
        playVideo();
      });

      video.addEventListener("pause", () => {
        if (video.ended) return;
        wrap.classList.remove("is-playing");
        playButton.hidden = false;
      });

      video.addEventListener("ended", () => {
        wrap.classList.remove("is-playing");
        playButton.hidden = false;
      });
    }
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => bindClickToPlay(), {
      once: true,
    });
  } else {
    bindClickToPlay();
  }

  document.addEventListener("shopify:section:load", (event) => {
    bindClickToPlay(event.target);
  });
})();
